import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import ControlPanelLogin from './content/pages/ControlPanelLogin';
import JoinLotteryPage from './content/pages/external/JoinLotteryPage';
import LuckyNumberPage from './content/pages/external/LuckyNumberPage';
import QRCodeDisplayPage from './content/pages/external/QRCodeDisplayPage';
import DefaultChannelPage from './content/pages/external/DefaultChannelPage';
import ChannelViewPage from './content/pages/external/ChannelViewPage';
import PublicLotteryPage from './content/pages/external/PublicLotteryPage';
import UserManagement from './content/pages/management/user/UserManagement';
import LotteryManagement from './content/pages/management/lottery/LotteryManagement';
import ActiveLotteries from './content/pages/management/lottery/ActiveLotteries';
import PrizeManagement from './content/pages/management/prize/PrizeManagement';
import ParticipationHistory from './content/pages/history/participation/ParticipationHistory';
import NotificationSettings from './content/pages/settings/notification/NotificationSettings';
import SystemSettings from './content/pages/settings/system/SystemSettings';
import PrivateRoute from './util/privateRoute';
import PrivacyPage from './content/pages/external/PrivacyPage';
import LocationsManagement from './content/pages/management/locations/LocationsManagement';
import MediaManagement from './content/pages/management/media/MediaManagement';
import Campaigns from './content/pages/management/Campaigns/Campaigns';
import LeadsLists from './content/pages/management/LeadsLists/LeadsLists';
import Leads from './content/pages/management/Leads/Leads';
import Channels from './content/pages/management/Channels/Channels';
import PrivacyPolicy from './content/pages/management/PrivacyPolicy/PrivacyPolicy';

// Status Pages
import Status404 from 'src/content/pages/Status/Status404';
import Status500 from 'src/content/pages/Status/Status500';
import StatusComingSoon from 'src/content/pages/Status/ComingSoon';
import StatusMaintenance from 'src/content/pages/Status/Maintenance';
import Redeem from "./content/pages/management/redeem/Redeem";

export default function routing(): RouteObject[] {
  const routes: RouteObject[] = [
    // 🔹 Öffentliche Seiten
    {
      path: '',
      element: <BaseLayout />,
      children: [
        {
          path: '/',
          element: <StatusComingSoon />
        },
        {
          path: '/privacy',
          element: <PrivacyPage />
        },
        {
          path: '/join/:id',
          element: <JoinLotteryPage />
        },
        {
          path: '/lucky-number',
          element: <LuckyNumberPage />
        },{
          path: '/home',
          element: <DefaultChannelPage />
        },
        {
          path: '/channel/:name',
          element: <ChannelViewPage />
        },
        {
          path: '/lottery/:lotteryId',
          element: <PublicLotteryPage />
        },
        {
          path: 'status',
          children: [
            { path: '', element: <Navigate to="404" replace /> },
            { path: '404', element: <Status404 /> },
            { path: '500', element: <Status500 /> },
            { path: 'maintenance', element: <StatusMaintenance /> },
            { path: 'coming-soon', element: <StatusComingSoon /> }
          ]
        },
        { path: '*', element: <Status404 /> }
      ]
    },

    // 🔹 Control Panel (Login + geschützte Bereiche)
    {
      path: 'cp',
      element: <BaseLayout />,
      children: [
        { path: '', element: <Navigate to="login" replace /> },
        { path: 'login', element: <ControlPanelLogin /> },

        // 🔹 Geschützte Routen
        {
          path: 'qrcode',
          element: <PrivateRoute component={QRCodeDisplayPage} requiredRoles={['tenant-owner', 'tenant-admin']} />
        },

        {
          path: 'overview',
          element: <PrivateRoute component={SidebarLayout} />,
          children: [
            { path: '', element: <DefaultChannelPage /> }
          ]
        },

        {
          path: 'management',
          element: <PrivateRoute component={SidebarLayout} />,
          children: [
            {
              path: '',
              element: <Navigate to="users" replace />
            },           
            { path: '', element: <Navigate to="users" replace /> },
            { path: 'users', element: <PrivateRoute component={UserManagement} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'lotteries', element: <PrivateRoute component={LotteryManagement} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'active-lotteries', element: <PrivateRoute component={ActiveLotteries} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'prizes', element: <PrivateRoute component={PrizeManagement} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'locations', element: <PrivateRoute component={LocationsManagement} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'media', element: <PrivateRoute component={MediaManagement} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'redeem', element: <PrivateRoute component={Redeem} requiredRoles={['tenant-employee']} /> },
            { path: 'campaigns', element: <PrivateRoute component={Campaigns} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'leadslists', element: <PrivateRoute component={LeadsLists} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'leads', element: <PrivateRoute component={Leads} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'channels', element: <PrivateRoute component={Channels} requiredRoles={['tenant-owner', 'tenant-admin']} /> },
            { path: 'privacypolicy', element: <PrivateRoute component={PrivacyPolicy} requiredRoles={['tenant-owner', 'tenant-admin']} /> }
          ]
        },

        {
          path: 'history',
          element: <PrivateRoute component={SidebarLayout} />,
          children: [
            { path: 'participation', element: <PrivateRoute component={ParticipationHistory} requiredRoles={['tenant-owner', 'tenant-admin']} /> }
          ]
        },

        {
          path: 'settings',
          element: <PrivateRoute component={SidebarLayout} />,
          children: [
            { path: 'notifications', element: <PrivateRoute component={NotificationSettings} requiredRoles={['tenant-owner', 'tenant-admin']}/> },
            { path: 'system', element: <PrivateRoute component={SystemSettings} requiredRoles={['tenant-owner', 'tenant-admin']} /> }
          ]
        }
      ]
    }
  ];

  return routes;
}
